import React, { Component } from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
//import "../pages/main.css"
import { Helmet } from "react-helmet"
import moment from "moment"
import "../scss/main.scss"

class Post extends Component {
  render() {
    const post = this.props.data.wordpressPost

    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{parse(post.title)}</title>
          <link
            rel="stylesheet"
            href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css"
            integrity="sha384-9aIt2nRpC12Uk9gS9baDl411NQApFmC26EwAOH8WgZl5MYYxFfc+NcPb1dKGj7Sk"
            crossorigin="anonymous"
          />
        </Helmet>
        <div className="o-container">
          <div className="o-row">
            <div
              className="o-col-10@lg u-mx-auto"
              style={{ textAlign: "center" }}
            >
              <h2
                className="c-blog-single__title"
                style={{ textAlign: "left" }}
              >
                {parse(post.title)}{" "}
              </h2>
              {post.featured_media !== null ? (
                <img
                  className="c-blog-single__image u-mb-5"
                  src={post.featured_media.source_url}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <div className="o-row row">
          <div className="o-col-2@md o-offset-1@lg col-2">
            <div className="c-blog-single__meta">
              {post.author !== null ? (
                <>
                  <a
                    className="c-blog-single__meta-pic"
                    href={post.author.link}
                  >
                    <img
                      src={post.author.avatar_urls.wordpress_96}
                      style={{ margin: "0 auto" }}
                    />
                  </a>
                  <a
                    href={post.author.link}
                    className="c-blog-single__meta-name"
                  >
                    {post.author.name}
                  </a>
                  <span className="c-blog-single__meta-position">
                    {post.author.acf.extremenetworks_user_company_role_position}
                  </span>
                </>
              ) : (
                ""
              )}

              <span className="c-blog-single__meta-date">
                {moment(post.date).format("MMMM Do YYYY")}
              </span>
            </div>
          </div>
          <div className="o-col-10@md o-col-7@lg col-10">
            <div className="c-standard-content">{parse(post.content)}</div>
          </div>
        </div>
      </>
    )
  }
}

export default Post

export const postQuery = graphql`
  query($id: String!) {
    wordpressPost(id: { eq: $id }) {
      title
      date
      content
      featured_media {
        source_url
      }
      author {
        name
        avatar_urls {
          wordpress_96
        }
        acf {
          extremenetworks_user_company_role_position
        }
      }
    }
  }
`
